import React from 'react';
import styled from 'styled-components';
import {
  colors,
  fonts,
  breakpoints,
  headingStyle,
  bodyTextStyle,
  containerStyle,
  sectionPaddingStyle,
} from './designSystem';

// ---------------------------------------------------------------------------
// Styled Components
// ---------------------------------------------------------------------------

const Section = styled.section`
  margin: 0;
  ${sectionPaddingStyle}
  background-color: ${colors.white};
`;

const Container = styled.div`
  ${containerStyle}
  max-width: 820px;
`;

const Heading = styled.h2`
  ${headingStyle}
  font-size: 1.5rem;
  margin-bottom: 20px;

  @media (min-width: ${breakpoints.mobile}) {
    font-size: 2rem;
  }
`;

const Emphasis = styled.span`
  color: ${colors.bleu};
`;

const Content = styled.div`
  ${bodyTextStyle}
  color: ${colors.textSecondary};

  p {
    margin-bottom: 16px;
  }

  ul {
    padding-left: 20px;
    margin-bottom: 16px;
  }

  li {
    margin-bottom: 8px;
  }

  strong {
    color: ${colors.textDark};
  }
`;

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export default function VilleSEOContent({ name, seoVille }) {
  if (!seoVille) return null;

  const text = seoVille.introduction_seo || seoVille.contenu_seo_ville || null;
  if (!text) return null;

  return (
    <Section>
      <Container>
        <Heading>
          {seoVille.h2_seo_ville || (
            <>
              R&eacute;paration v&eacute;lo &agrave;{' '}
              <Emphasis>{name || ''}</Emphasis>
            </>
          )}
        </Heading>
        <Content dangerouslySetInnerHTML={{ __html: text }} />
      </Container>
    </Section>
  );
}
